"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpURL = void 0;
class HttpURL {
    constructor(endpoint, pathBuilderOrPath) {
        this.endpoint = endpoint;
        this.pathBuilderOrPath = pathBuilderOrPath;
    }
    toString(payload) {
        const path = typeof this.pathBuilderOrPath === 'string'
            ? this.pathBuilderOrPath
            : this.pathBuilderOrPath(payload);
        const purePath = path.replace(/^\/+/, '').replace(/\/+/, '/');
        const pureEndpoint = this.endpoint.replace(/\/+$/, '');
        return `${pureEndpoint}/${purePath}`.replace(/\/+$/, '');
    }
}
exports.HttpURL = HttpURL;
//# sourceMappingURL=HttpURL.js.map